var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { stringBuilder } from '../util';
import { noop } from 'lodash';
import TuxBasicInput from './BasicInput';
const TuxTextInput = forwardRef(function TuxTextInput(props, ref) {
    const { 'aria-autocomplete': ariaAutocomplete, 'aria-activedescendant': ariaActiveDescendant, 'aria-expanded': ariaExpanded, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autocomplete, disabled = false, helperText, id, inputClasses, invalid = false, isClearable = false, label, labelClasses, large = false, max, maxLength, min, name, onBlur = noop, onChange, onClear = noop, pattern, placeholder, plainText = false, readonly = false, required = false, role, small = false, type = 'text', validationText, value } = props, rest = __rest(props, ['aria-autocomplete', 'aria-activedescendant', 'aria-expanded', 'aria-label', 'aria-labelledby', "autocomplete", "disabled", "helperText", "id", "inputClasses", "invalid", "isClearable", "label", "labelClasses", "large", "max", "maxLength", "min", "name", "onBlur", "onChange", "onClear", "pattern", "placeholder", "plainText", "readonly", "required", "role", "small", "type", "validationText", "value"]);
    const labelClassName = stringBuilder('tuxedo_label', { disabled, required }, labelClasses);
    const validationClassName = stringBuilder('validation-state', {
        error: invalid,
        success: !invalid
    });
    const helperTextClassName = stringBuilder('form-text', { disabled });
    const helperId = helperText ? `helper-${id}` : undefined;
    const validationId = validationText ? `validation-text-${id}` : undefined;
    const describedBy = stringBuilder(helperId, validationId);
    const inputProps = Object.assign({ 'aria-autocomplete': ariaAutocomplete, 'aria-activedescendant': ariaActiveDescendant, 'aria-expanded': ariaExpanded, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': describedBy, 'aria-invalid': invalid, 'aria-required': required, autoComplete: autocomplete, disabled,
        id,
        inputClasses,
        invalid,
        isClearable,
        large,
        maxLength,
        max,
        min, name: name || id, onBlur,
        onChange,
        onClear,
        pattern,
        placeholder,
        plainText,
        readonly,
        ref,
        required,
        role,
        small,
        type,
        value }, rest);
    return (_jsxs(_Fragment, { children: [label && (_jsx("label", Object.assign({ className: labelClassName, htmlFor: id }, { children: label }), void 0)), helperText && (_jsx("small", Object.assign({ className: helperTextClassName, id: helperId }, { children: helperText }), void 0)), maxLength && (_jsxs("span", Object.assign({ className: "sr-only", id: `counter_${id}` }, { children: ["maximum length ", maxLength, " characters"] }), void 0)), _jsx(TuxBasicInput, Object.assign({}, inputProps), void 0), validationText && (_jsx("div", Object.assign({ className: validationClassName, id: validationId, role: "alert" }, { children: validationText }), void 0))] }, void 0));
});
export default TuxTextInput;
